import styled from 'styled-components'

import { ReactComponent as SmallArrowLeftSVG } from 'assets/images/small-arrow-left.svg'

export const BackIcon = styled(SmallArrowLeftSVG)`
  color: ${({ theme }) => theme.colors.niceBlue};
  width: ${(props) => props.theme.fontSizes.md};
  margin-right: ${(props) => props.theme.spacings[2]};
`
